import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

interface GlAdjustmentInfo {
  id: number;
  pId: string;
  participantType: string;
  participantName: string;
  amount: string;
  adjustmentCategory: string;
  adjustmentDescription: string;
  loanNumber: string;
  adjustmentComponent: string;
  postingDate: string | null;
  adjustmentType: string;
  rowsPerPage: number;
  page: number;
  comments: string;
  loanId: string;
  searchParticipantName: string;
  searchAdjustmentCategory: string;
  searchStatus: string;
  searchRowsPerPage: number;
  searchPage: number;
   glAdminView:boolean,
  glInfo: {
    id: number;
    loanId: string;
  };
}

const initialState: GlAdjustmentInfo = {
  id: 0,
  pId: "",
  participantType: "",
  participantName: "",
  amount: "",
  adjustmentCategory: "",
  adjustmentDescription: "",
  adjustmentComponent: "",
  loanNumber: "",
  postingDate: dayjs().toISOString(),
  adjustmentType: "Credit",
  rowsPerPage: 5,
  page: 0,
  comments: "",
  loanId: "",
  searchParticipantName: "All",
  searchAdjustmentCategory: "All",
  searchStatus: "All",
  searchRowsPerPage: 5,
  searchPage: 0,
  glAdminView:false,
  glInfo: {
    id: 0,
    loanId: "",
  },
};

const createGlAdjustmentSlice = createSlice({
  name: "createGLAdjustment",
  initialState,
  reducers: {
    setCreateGlAdjustmentSlice: (
      state,
      action: PayloadAction<Partial<GlAdjustmentInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeGlAdjustment: () => initialState,
  },
});

export const { setCreateGlAdjustmentSlice, removeGlAdjustment } =
  createGlAdjustmentSlice.actions;
export default createGlAdjustmentSlice.reducer;
